import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false, 
};

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    setApiLoader: (state) => {
      state.isLoading = true; 
    },
    resetApiLoader: (state) => {
      state.isLoading = false; 
    },
  },
});

export const { setApiLoader, resetApiLoader } = loaderSlice.actions;

export default loaderSlice.reducer;